import React, { useEffect, useState } from 'react'
import StudentSidebar from '../../StudentSidebar/StudentSidebar'
import { Link, useNavigate, useParams } from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux';
import { getGroupCourseBatchSessionList } from '../../../../Redux/action/StudentAction';
import { useFormik } from 'formik';
import axios from 'axios';
import { toast } from 'react-hot-toast';
import * as Yup from "yup";
import { Modal, ModalBody  } from "react-bootstrap";
import Beatloader from '../../../../Common/BeatLoader';
import moment from "moment-timezone";
import { jwtDecode } from "jwt-decode";
const host = process.env.REACT_APP_API_SERVER
const StudentGroupBatchSession = () => {
    const dispatch = useDispatch();
    const { b64id } = useParams();
    const navigate = useNavigate();
    const authToken = localStorage.getItem('student-token');
    const decoded = jwtDecode(authToken);
    const [showPaymentModal, setShowPaymentModal] = useState(false);

    const currentTimezone = decoded?.user?.time_zone


    useEffect(() => {
        try {

            const BatchId = atob(b64id);


            if (!BatchId || isNaN(BatchId)) {
                throw new Error("Invalid course ID");
            }


            dispatch(getGroupCourseBatchSessionList(BatchId))
        } catch (error) {

            navigate(-1);
        }
    }, [b64id]);

    const [showModal, setShowModal] = useState(false);

    const {

        loadingGroupCourseBatchSessionListApi,
        GroupCourseBatchSessionListApiData,
        GroupCourseBatchSessionListApiError,

    } = useSelector(state => state?.StudentReducer);

    const [orderDetails, setOrderDetails] = useState({
        name: '',
        batch_name: '',
        description: '',
        experience: '',
        start_date: '',
        total_review_count: '',
        avarageRating: '',
        approval: '',
        discount: '',
        totalAmount: '',
        totalAmountWithSymbol: '',
        batch_session: [],
        batch_id: '',
        course_id: '',
    });


    const formik = useFormik({
        initialValues: {
            batch_session: [],
            course_id: GroupCourseBatchSessionListApiData?.batch_details?.course_id,
            batch_id: GroupCourseBatchSessionListApiData?.batch_details?.batch_id,
        },
        onSubmit: (values, { setSubmitting, resetForm }) => {
            values.course_id = GroupCourseBatchSessionListApiData?.batch_details?.course_id;
            values.batch_id = GroupCourseBatchSessionListApiData?.batch_details?.batch_id;

            try {

                setSubmitting(true);
                let config = {
                    headers: {
                        "x-auth-token": localStorage.getItem('student-token'),

                    },
                };

                axios.post(`${host}/api/student/browse-tutor/calculate-price-of-group-course`, values, config)

                    .then(res => {

                        if (res.status == 200) {

                            // toast.success(res.data.message);
                            setSubmitting(false);

                            setOrderDetails({
                                name: res.data.data.name,
                                batch_name: res.data.data.batch.batch_name,
                                description: res.data.data.description,
                                experience: res.data.data.tutor.experience,
                                start_date: res.data.data.start_date,
                                total_review_count: res.data.data.tutor.total_review_count,
                                avarageRating: res.data.data.tutor.avarageRating,
                                approval: res.data.data.approval_status == 'APPROVED' ? 'A' : 'D',
                                discount: res.data.data.course_discount_price,
                                totalAmount: res.data.data.total_course_price,
                                totalAmountWithSymbol: res.data.data.total_course_price_with_symbol,
                                course_id: res.data.data.batch.course_id,
                                batch_id: res.data.data.batch.id,
                                batch_session: res.data.data.batch_session
                            });
                            setShowModal(true);

                        } else {

                            toast.error(res.data.message);
                            setSubmitting(false);
                        }
                    }).catch(err => {

                        if (err.response) {
                            toast.error(err.response.data.message);
                        } else {
                            toast.error("Internal server error.")
                        }
                        setSubmitting(false);
                    });

            }
            catch (error) {

                console.log(error);
                toast.error(error.response.data.message);
                setSubmitting(false);

            }
        },
    });


    // useEffect(() => {
    //     if (GroupCourseBatchSessionListApiData?.batch_sessions) {
    //         const allBatchIds = GroupCourseBatchSessionListApiData.batch_sessions?.map(data => data.id);
    //         formik.setFieldValue("batch_session", allBatchIds);
    //     }
    // }, [GroupCourseBatchSessionListApiData]); 

    useEffect(() => {
        if (GroupCourseBatchSessionListApiData?.batch_sessions) {

            const currentDateTime = moment().tz(currentTimezone);

            const upcomingBatchIds = GroupCourseBatchSessionListApiData.batch_sessions
                .filter(session => {
                    const sessionDateTime = moment.tz(session?.time_slot?.formated_start_date_time, "YYYY-MM-DD HH:mm:ss", currentTimezone);

                    return sessionDateTime.isAfter(currentDateTime);
                })
                .map(session => session.id);

            formik.setFieldValue("batch_session", upcomingBatchIds);
        }
    }, [GroupCourseBatchSessionListApiData]);

    // console.log('GroupCourseBatchSessionListApiData?.batch_sessions', GroupCourseBatchSessionListApiData?.batch_sessions)

    const handleSelectAll = () => {
        const allBatchIds = GroupCourseBatchSessionListApiData?.batch_sessions?.map(data => data.id) || [];
        const currentlySelected = formik.values.batch_session.length === allBatchIds.length;

        // Toggle select all
        formik.setFieldValue("batch_session", currentlySelected ? [] : allBatchIds);
    };

    const handleCheckboxChange = (id) => {

        const selected = formik.values.batch_session;
        if (selected.includes(id)) {
            // Remove id if already selected
            formik.setFieldValue(
                "batch_session",
                selected.filter(batchId => batchId !== id)
            );
        } else {
            // Add id if not selected
            formik.setFieldValue("batch_session", [...selected, id]);
        }
    };

    const selectedCount = formik.values.batch_session.length;

    const handlePayment = async () => {
        try {
            const config = {
                headers: {
                    "Content-Type": "application/json",
                    "x-auth-token": localStorage.getItem("student-token"),
                },
            };
            const sessionIds = orderDetails?.batch_session?.map(
                (session) => session.id
            );

            const values = {
                order_type: "1",
                course_id: orderDetails?.course_id,
                batch_id: orderDetails?.batch_id,
                course_session: sessionIds,
                order_amount: orderDetails?.totalAmount,
            };
            if(orderDetails?.totalAmount=='0' || orderDetails?.totalAmount=='0.00'){
                const res = await axios.post(`${host}/api/payment/create-free-course`, values, config);

                if (res.data.statusCode == 200) {
                    setShowModal(false)
                   setShowPaymentModal(true)
                   setTimeout(() => {
                    setShowPaymentModal(false)
                    navigate('/student/dashboard');
                }, 1000);
    
    
                } else {
                    toast.error(res.data.message || "Failed to enroll course. Please try again.");
                }
            }else{
           


            const res = await axios.post(`${host}/api/payment/create-intent-new`, values, config);

            if (res.data.statusCode == 200) {
                const clientSecret = res.data.data.client_secret;


                navigate('/student/session-payment', { state: { user: res.data.data } })


            } else {
                toast.error(res.data.message || "Payment failed. Please try again.");
            }
        }
        } catch (err) {
            console.error("Error processing payment:", err);
            const errorMessage = err.response?.data?.message || "Something went wrong";
            toast.error(errorMessage);
        }
        
    };

    return (
        <div>
            <section className="after-header">
                {/* Breadcrum Start */}
                <nav aria-label="breadcrumb">
                    <ol className="breadcrumb bg-light">
                        <li className="breadcrumb-item  ps-5" aria-current="page">
                            <a href="javascript:history.back()">
                                <i className="fa-solid fa-chevron-left text-dark" />
                            </a>
                            &nbsp;&nbsp;Group Course Batch Sessions
                        </li>
                    </ol>
                </nav>
                {/* Breadcrum End */}
                <div className="main-container-sec">
                    <div className="row mx-0">
                        <div className="col-lg-3">
                            <StudentSidebar />
                        </div>
                        <div className="col-lg-9">
                            {loadingGroupCourseBatchSessionListApi ?
                                <Beatloader />
                                :
                                <main className="px-3 py-4">
                                    <div className="card input-card-form">
                                        <div className="card-body">
                                            <div className="row">
                                                <div className="col-lg-6">
                                                    <p className="mb-1">Total Seat-{GroupCourseBatchSessionListApiData?.batch_details?.total_seats}</p>
                                                </div>
                                                <div className="col-lg-6">
                                                    <p className="text-end mb-1">Seat Left-{GroupCourseBatchSessionListApiData?.batch_details?.seats_left}</p>
                                                </div>
                                                <div className="col-lg-12">
                                                    <h5 className="mb-0">Batch Name : {GroupCourseBatchSessionListApiData?.batch_details?.batch_name}</h5>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    {/* <div className="row my-3">
                                        <div className="col-lg-12 d-flex justify-content-end">
                                            <button
                                                type="button"
                                                className="btn btn-outline-primary"
                                                onClick={handleSelectAll}
                                            >
                                                {formik.values.batch_session.length ===
                                                    (GroupCourseBatchSessionListApiData?.batch_sessions?.length || 0)
                                                    ? "Deselect All"
                                                    : "Select All"}
                                            </button>
                                        </div>
                                    </div> */}
                                    <div className="row">
                                        {GroupCourseBatchSessionListApiData?.batch_sessions?.map((data, index) => {

                                            const sessionDateTime = moment.tz(
                                                data?.time_slot?.formated_start_date_time,
                                                "YYYY-MM-DD HH:mm:ss",
                                                currentTimezone
                                            );

                                            const isExpired = sessionDateTime.isBefore(moment().tz(currentTimezone));
                                            return (
                                                <div className="col-lg-6 col-md-6 mb-3" key={data?.id}>
                                                    <div className="card">
                                                        <div className="card-body">
                                                            <div className="row">
                                                                <div className="col-md-12 d-flex justify-content-between">
                                                               {isExpired ?
                                                                <div >
                                                                <p className="mb-0 fw-bold text-danger">
                                                                     Expired
                                                                </p>
                                                            </div>
                                                            :
                                                                <div >
                                                                    <input
                                                                        name={`options-${data.id}`} // Unique name for each checkbox
                                                                        type="checkbox"
                                                                        value={data.id}
                                                                        checked={formik.values.batch_session.includes(Number(data.id))}
                                                                        // onChange={() => handleCheckboxChange(data.id)}
                                                                        style={{ height: 18, width: 18 }}
                                                                    />

                                                                </div>
                                                                
                                                               }
                                                                </div>
                                                                <div className="col-lg-6 mb-2">
                                                                    <div className="card">
                                                                        <div className="card-body" style={{ height: '100px' }}>
                                                                            <p className="mb-0">Session Start Date</p>
                                                                            <div className="row">
                                                                                <div className="col-lg-10">
                                                                                    <p className="mb-0 fw-bold" style={{ fontSize: 14 }}>
                                                                                        {data?.formated_start_date}
                                                                                    </p>

                                                                                </div>
                                                                                <div className="col-lg-2">
                                                                                    <i className="fa-solid fa-calendar-days fw-bold" />
                                                                                </div>
                                                                            </div>

                                                                        </div>
                                                                    </div>
                                                                </div>
                                                                <div className="col-lg-6 mb-2">
                                                                    <div className="card">
                                                                        <div className="card-body" style={{ height: '100px' }}>
                                                                            <p className="mb-0">Session Time</p>
                                                                            <div className="row">
                                                                                <div className="col-lg-10">
                                                                                    <p className="mb-0 fw-bold" style={{ fontSize: 14 }}>
                                                                                        {data?.time_slot?.formated_start_end_time} ({data?.timeZoneAbb})
                                                                                    </p>
                                                                                </div>
                                                                                <div className="col-lg-2">
                                                                                    <i className="bi bi-clock-fill fw-bold" />
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                                <div className="col-lg-12">
                                                                    <div className="card">
                                                                        <div className="card-body py-2">
                                                                            <p className="mb-0">{data?.topic_details}</p>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            )
                                        })}
                                    </div>
                                    <hr />
                                    <div className="card">
                                        <div className="card-body">
                                            <div className="row">
                                                <div className="col-lg-10 col-md-10 col-10">
                                                    <h5 className="mb-2 fw-bold">Total No. of Sessions</h5>
                                                </div>
                                                <div className="col-lg-2 col-md-2 col-2">
                                                    <h5 className="mb-2 text-primary fw-bold text-end">{selectedCount}</h5>
                                                </div>
                                                <div className="col-lg-12 col-md-12">
                                                    <div className="row d-flex justify-content-end">
                                                        <div className="col-lg-3 col-md-4">
                                                            <button
                                                                disabled={formik.isSubmitting}
                                                                className="btn btn-primary mt-3 w-100"
                                                                type="button"
                                                                onClick={formik.handleSubmit}
                                                            >
                                                                Book Session Now
                                                            </button>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </main>
                            }
                        </div>
                    </div>
                </div>
            </section>
            <>
                {/* Order Details Modal */}


                <Modal
                    className='modal tutor-details-modal border-0'
                    show={showModal}
                    onHide={() => setShowModal(false)}
                >
                    <Modal.Header closeButton>
                        <Modal.Title>Order Details</Modal.Title>
                    </Modal.Header>
                    <Modal.Body className='border-0'>
                        <div className="row">
                            <div className="col-lg-12 mt-3">
                                <div className="card input-card-form bg-white">
                                    <div className="card-body">
                                        <div className="row position-relative">
                                            <div className="position-absolute">
                                                <p className="mb-0 text-end" style={{ fontSize: 13 }}>
                                                    <i>{orderDetails.approval}</i>
                                                </p>
                                                {/* <p className="mb-0 text-end" style={{ fontSize: 13 }}>
                                                    {orderDetails.start_date || '2024-11-01'} 
                                                </p> */}
                                            </div>
                                            <div className="col-lg-4">
                                                <img
                                                    src={`${host}${orderDetails?.profile_img}`}
                                                    onError={(e) => {
                                                        e.target.src = '/assets/img/user/user.png'; // Fallback image
                                                    }}
                                                    className="img-fluid rounded-circle"
                                                    style={{ height: "7.6rem", width: "auto" }}
                                                />
                                            </div>
                                            <div className="col-lg-8">
                                                <h5 className="mb-0 text-dark">{orderDetails.name}</h5>
                                                <p className="mb-0">{orderDetails.batch_name}</p>
                                                <p className="mb-0">{orderDetails.description}</p>
                                                {orderDetails.experience && <p className="mb-0">{orderDetails.experience}</p>}
                                                <div className="rating">
                                                    {Array.from({ length: 5 }, (_, index) => {
                                                        // Ensure the rating is parsed as a float
                                                        const averageRating = parseFloat(orderDetails?.avarageRating || "0");

                                                        // Calculate if the current star should be full, half, or empty
                                                        if (index < Math.floor(averageRating)) {
                                                            // Full star
                                                            return <i key={index} className="fas fa-star filled" />;
                                                        } else if (index < averageRating) {
                                                            // Half star (only if there's a decimal)
                                                            return <i key={index} className="fas fa-star-half-alt filled" />;
                                                        } else {
                                                            // Empty star
                                                            return <i key={index} className="fas fa-star" />;
                                                        }
                                                    })}

                                                    <span>
                                                        {orderDetails.avarageRating} <span className="text-primary">({orderDetails.total_review_count} Ratings)</span>
                                                    </span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="col-lg-12 mt-3">
                                <div className="card">
                                    <div className="card-body">
                                        <div className="row">
                                            <div className="col-lg-6">
                                                <p className="mb-0">Discount</p>
                                            </div>
                                            <div className="col-lg-6">
                                                <p className="mb-0 text-end">{orderDetails.discount}</p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </Modal.Body>
                    <div className="modal-footer">
                        <div className="row w-100">
                            <div className="col-lg-6">
                                <p className="mb-0 fw-bold">Total Amount</p>
                            </div>
                            <div className="col-lg-6">
                                <p className="mb-0 text-end text-primary fw-bold">{orderDetails.totalAmountWithSymbol}</p>
                            </div>
                        </div>
                        <Link
                            //   to="/student/session-payment"
                            className="w-100">
                            <button onClick={handlePayment} className="btn btn-primary w-100" data-bs-dismiss="modal">Checkout</button>
                        </Link>
                    </div>
                </Modal>
                {/* Payment Modal */}
                <Modal
                    show={showPaymentModal} onHide={() => setShowPaymentModal(false)}
                    className="logout-modal"
                    id="paymentModal"
                    tabIndex={-1}

                >

                    <ModalBody

                        className="modal-body my-4"
                    // style={{
                    //     display: "flex",
                    //     flexDirection: "column",
                    //     alignItems: "center",
                    //     justifyContent: "center"
                    // }}
                    >
                        <img src="/assets/img/user/verified.gif" alt="" srcset="" />
                        <h4 className="mt-3">Enrollment succeeded!</h4>
                        <p className="text-center">
                            Your enrollment was completed successfully.
                            <br />
                            Thank you for enrolling!
                        </p>
                        <Link to="/student/dashboard">
                            <button
                                type="button"
                                className="btn btn-success"
                                data-bs-dismiss="modal"
                            >
                                Go To Your Dashboard
                            </button>
                        </Link>
                    </ModalBody>

                </Modal>

            </>

        </div>
    )
}

export default StudentGroupBatchSession